import { useCallback, useMemo } from 'react';
import type { SendbirdGroupChannel } from '@sendbird/uikit-utils';
import { useI18n } from '@shared/i18n/useI18n';
import type { TChannelTitleLabels } from '../types';
import { getChannelTitle } from '../utils/channelTitle';

export const useChannelTitleResolver = () => {
    const { t } = useI18n();
    const labels = useMemo<TChannelTitleLabels>(
        () => ({
            technicalSupport: t('screens.chat.channelTitle.technicalSupport'),
            team: t('screens.chat.channelTitle.team'),
        }),
        [t],
    );

    return useCallback((channel: SendbirdGroupChannel) => getChannelTitle(channel, labels), [labels]);
};

export const useChannelTitle = (channel: SendbirdGroupChannel | null): string | null => {
    const resolveTitle = useChannelTitleResolver();
    return channel ? resolveTitle(channel) : null;
};
